/* === digital-letter.js (robust save + checkout guard + preview) === */
document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.getElementById("digitalLetterToggle");
  var form = document.getElementById("digitalLetterForm");
  if (!toggle) return;

  if (toggle.checked && form) form.style.display = "block";

  toggle.addEventListener("change", function () {
    if (!form) return;
    form.style.display = toggle.checked ? "block" : "none";
  });

  var templates = {
    best: "This little gift carries a big message—you matter to me more than words can say. Thank you for filling my life with joy, laughter, and comfort.",
    mom: "This small gift comes with all my love. Thank you for your endless care, strength, and warmth. You make my world better every single day.",
    love: "You’re the one who lights up my world. Being with you feels like magic—pure, gentle, and real. You fill my days with joy, warmth, and a love I never knew I needed. Every moment with you is a treasure I hold close.",
    kind: "Your kindness, love, and warmth keep me grounded in ways words can’t describe. Every memory with you feels precious, and you make life gentler, happier, and beautifully meaningful just by being yourself."
  };

  var buttons = document.querySelectorAll(".dl-btn");
  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.dataset.template;
      var msgBox = document.getElementById("digitalMessage");
      if (msgBox && templates[key]) msgBox.value = templates[key];
      updateHiddenInputs();
    });
  });

  var previewBtn = document.getElementById("previewLetter");
  if (previewBtn) {
    previewBtn.addEventListener("click", function () {
      var to = (document.getElementById("toName") || {}).value || "";
      var from = (document.getElementById("fromName") || {}).value || "";
      var msg = (document.getElementById("digitalMessage") || {}).value || "";

      var html =
        '<div style="padding:36px 16px;text-align:center;color:#111;font-family:Arial,Helvetica,sans-serif;">' +
        '<h2 style="text-transform:capitalize;margin-bottom:12px;">Dear ' + escapeHtml(to) + '</h2>' +
        '<div style="max-width:420px;margin:0 auto;line-height:1.6;text-align:center;">' +
        '<p style="white-space:pre-wrap;">' + escapeHtml(msg) + '</p>' +
        (from ? '<p style="margin-top:18px;font-weight:600;">— ' + escapeHtml(from) + '</p>' : '') +
        '</div></div>';

      var modal = document.getElementById("letterPreviewModal");
      var content = document.getElementById("previewContent");
      if (modal && content) {
        content.innerHTML = html;
        modal.style.display = "block";
      }
    });
  }

  var closeBtn = document.getElementById("closePreview");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      var modal = document.getElementById("letterPreviewModal");
      if (modal) modal.style.display = "none";
    });
  }

  // Hidden inputs helpers
  function ensureHiddenInputs() {
    var formEl = document.querySelector('form[action="/cart"]') || document.body;
    var names = [
      "digital_letter_message",
      "digital_letter_to",
      "digital_letter_from"
    ];

    names.forEach(function (name) {
      var inputName = 'attributes[' + name + ']';
      var existing = document.querySelector('input[name="' + inputName + '"].dl-hidden');
      if (!existing) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = inputName;
        hidden.className = 'dl-hidden';
        hidden.value = '';
        formEl.appendChild(hidden);
      }
    });

    updateHiddenInputs();
  }

  function updateHiddenInputs() {
    var msg = (document.getElementById("digitalMessage") || {}).value || "";
    var to = (document.getElementById("toName") || {}).value || "";
    var from = (document.getElementById("fromName") || {}).value || "";

    var map = {
      "digital_letter_message": msg,
      "digital_letter_to": to,
      "digital_letter_from": from
    };

    Object.keys(map).forEach(function (key) {
      var sel = 'input[name="attributes[' + key + ']"].dl-hidden';
      var el = document.querySelector(sel);
      if (el) el.value = map[key];
    });
  }

  ['digitalMessage','toName','fromName','digitalPhone'].forEach(function(id){
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', updateHiddenInputs);
  });

  ensureHiddenInputs();

  // Save / Update
  var saveBtn = document.getElementById("saveLetter");
  var status = document.getElementById("digitalLetterStatus");

  function buildAttrsPayload(enabled) {
    var msg = (document.getElementById("digitalMessage") || {}).value.trim() || "";
    var to = (document.getElementById("toName") || {}).value.trim() || "";
    var from = (document.getElementById("fromName") || {}).value.trim() || "";

    if (enabled && (msg || to || from )) {
      return {
        digital_letter_message: msg,
        digital_letter_to: to,
        digital_letter_from: from
      };
    } else {
      return {
        digital_letter_message: "",
        digital_letter_to: "",
        digital_letter_from: ""
      };
    }
  }

  function doCartUpdate(attrs) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart update failed");
      return res.json();
    });
  }

  if (saveBtn) {
    saveBtn.addEventListener("click", function () {
      var enabled = toggle.checked;
      var attrs = buildAttrsPayload(enabled);

      var originalText = saveBtn.textContent;
      saveBtn.disabled = true;
      saveBtn.textContent = "Saving...";

      doCartUpdate(attrs)
        .then(function () {
          saveBtn.textContent = "Update letter";
          saveBtn.disabled = false;
          saveBtn.setAttribute("data-existing", "true");
          updateHiddenInputs();

          if (status) {
            status.textContent = "Digital letter saved with your cart.";
            status.style.color = "#4caf50";
            status.style.display = "inline";
            setTimeout(function () { status.style.display = "none"; }, 4000);
          }
        })
        .catch(function (err) {
          console.error("Digital letter save error", err);
          saveBtn.textContent = originalText;
          saveBtn.disabled = false;
          if (status) {
            status.textContent = "Could not save. Please try again.";
            status.style.color = "#d32f2f";
            status.style.display = "inline";
          }
        });
    });
  }

  // Checkout intercept
  function findCheckoutButtons() {
    var selectors = [
      'a[href^="/checkout"]',
      'form[action^="/checkout"] button[type="submit"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      '.cart__checkout',
      '.btn--checkout',
      '.checkout'
    ];
    var nodes = [];
    selectors.forEach(function(sel) {
      var found = document.querySelectorAll(sel);
      if (found && found.length) {
        found.forEach(function(n){ nodes.push(n); });
      }
    });
    return nodes;
  }

  function attachCheckoutGuard() {
    var buttons = findCheckoutButtons();
    if (!buttons || buttons.length === 0) return;

    buttons.forEach(function (btn) {
      if (btn.dataset.dlGuardAttached) return;
      btn.dataset.dlGuardAttached = "1";

      btn.addEventListener("click", function (e) {
        var enabled = toggle.checked;
        var attrs = buildAttrsPayload(enabled);

        e.preventDefault();
        e.stopPropagation();

        try { btn.disabled = true; } catch (e) {}

        doCartUpdate(attrs).catch(function(err){
          console.error("Checkout pre-save failed:", err);
        }).finally(function () {
          try { btn.disabled = false; } catch (er) {}

          if (btn.tagName.toLowerCase() === 'a' && btn.href) {
            window.location = btn.href;
            return;
          }

          var frm = btn.closest('form');
          if (frm) { frm.submit(); return; }

          window.location = "/checkout";
        });
      }, {passive:false});
    });
  }

  attachCheckoutGuard();
  setTimeout(attachCheckoutGuard, 800);
  setTimeout(attachCheckoutGuard, 2000);

  function escapeHtml(text) {
    var map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    return String(text).replace(/[&<>"']/g, function (m) { return map[m]; });
  }
});
